<template>
  <tr>
    <td>
      <sui-button v-for="action in actionList.filter((action) =>
        (license.status === 'draft' && action !== 'Pay') ||
        (license.status !== 'draft'),
      )" v-bind:content="action" v-on:click="buttonAction(action)" v-bind:key="action" />
    </td>
    <td v-if="showSchool">
      {{ license.schoolName }} ({{ license.schoolRollNumber }})
    </td>
    <td v-if="!hideDetails">
      <span v-if="license.licenseModel !== 'other'">
        {{ license.startDate | moment('DD-MM-YYYY') }} -
        {{ license.endDate | moment('DD-MM-YYYY') }}
      </span>
      <span v-else>-</span>
    </td>
    <td v-if="!hideDetails">{{ license.studentCount }}</td>
    <td v-if="!hideDetails">
      {{ license.status !== 'draft' ? 'Invoice' : 'Quote' }} -
      {{
        license.licenseModel === 'perstudent'
          ? 'Per student'
          : license.licenseModel === 'fixedprice'
            ? 'Fixed price'
            : 'Other'
      }}
    </td>
    <td>{{ formatAsPrice(license.amount) }}</td>
    <td v-if="!showPaidDate" v-bind:class="dueAtStyling(license.status, license.dueAt, license.balance)">
      {{ dueAt(license.status, license.dueAt, license.balance) }}
    </td>
    <td>
      {{ license.status !== 'draft' ? formatAsPrice(license.paid) : 'N/A' }}
    </td>
    <td v-if="showPaidDate">
      {{ paymentDate(license.status, license.lastPaymentDate) }}
    </td>
    <td v-if="!showPaidDate">
      {{ license.status !== 'draft' ? formatAsPrice(license.balance) : 'N/A' }}
    </td>
    <td>
      <sui-button v-if="license.status !== 'draft'" title="Download invoice" content="Invoice" icon="pdf file outline"
        primary v-on:click="downloadInvoice">
      </sui-button>
      <sui-button v-if="license.status === 'draft'" title="Download quote" content="Quote" icon="pdf file outline"
        primary v-on:click="downloadInvoice">
      </sui-button>
    </td>
  </tr>
</template>

<script>
import moment from 'moment';
import schoolsApi from '@/api/schools';

export default {
  name: 'InvoiceTableRow',
  props: ['license', 'actions', 'showSchool', 'showPaidDate', 'hideDetails'],
  data() {
    return { currentDate: moment() };
  },
  computed: {
    actionList() {
      return this.actions || [];
    },
  },
  methods: {
    downloadInvoice() {
      this.$store.dispatch('showLoader');
      schoolsApi
        .getInvoice(this.license.schoolId, this.license.id)
        .then((response) => {
          const blob = new Blob([response.data], { type: response.data.type });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          const fileName = `${this.license.status !== 'draft' ? 'Invoice' : 'Quote'
            }-${this.license.schoolRollNumber}-${this.license.schoolName}-${this.license.createdAt
            }.pdf`;
          link.setAttribute('download', fileName);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);
        })
        .finally(() => {
          this.$store.dispatch('hideLoader');
        });
    },
    formatAsPrice(value) {
      const formattedNumber = value.toFixed(2);
      const [integerPart, decimalPart] = formattedNumber.split('.');

      const formattedInteger = parseInt(integerPart, 10).toLocaleString(
        undefined,
        {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        },
      );

      return `€${formattedInteger}${decimalPart ? '.' : ''}${decimalPart || ''
        }`;
    },
    dueAtStyling(status, value, balance) {
      balance = Math.round(balance * 100) / 100;
      if (
        status !== 'draft') {
        if (balance > 0 &&
          moment(value).diff(this.currentDate, 'days') <= 0) {
          return 'ui negative message';
        } else {
          if (balance === 0) {
            return 'ui positive message';
          }
        }
      }
      return '';
    },
    dueAt(status, value, balance) {
      balance = Math.round(balance * 100) / 100;
      if (status !== 'draft') {
        if (balance > 0) {
          return moment(value).format('DD-MM-YYYY');

        } else {
          return 'paid';
        }
      }
      return 'N/A';
    },
    paymentDate(status, value) {
      if (status !== 'draft') {
        return moment(value).format('DD-MM-YYYY');
      }
      return 'N/A';
    },
    buttonAction(value) {
      this.$emit('action', { action: value, id: this.license.id });
    },
    buttonContent(status) {
      return status !== 'draft' ? 'Invoice' : 'Quote';
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/invoices/InvoiceTableRow.vue